import React from 'react'
import FinishIcon from 'images/finishprofile.svg'
import analytics from 'global/AnalyticsData'
import { navigate } from 'gatsby'

import './CompleteProfileModal.scss'

const CompleteProfileModal = ({ closeModal }) => {
  const goToProfile = () => {
    navigate('/profile')
    closeModal()
  }
  return (
    <>
      <div className={`modal-complete-profile`}>
        <img className="header-image" src={FinishIcon} alt="" />
        <div className="modal-complete-profile__content">
          <h1>We're Missing Something..</h1>
          <p>Looks like your profile isn't complete!</p>

          <button
            /* onClick={goToProfile} */
            onClick={e => {
              analytics.trackEvent('incomplete_profile_modal_complete')
              goToProfile()
            }}
          >
            Complete Profile
          </button>
          <a
            /* onClick={closeModal} */
            onClick={e => {
              analytics.trackEvent('incomplete_profile_modal_dismiss')
              closeModal()
            }}
          >
            Not now
          </a>
        </div>
      </div>
    </>
  )
}

export default CompleteProfileModal
